import axios from 'axios';

const instance = axios.create();

export const cancelToken = axios.CancelToken;

export default instance;
